export class Terminal {

    /** Name of the id of the terminal in the program */
    termianlHostName: string;
    /** Reference to the enter button */
    enterBut: HTMLButtonElement;
    /** Reference to container for terminal */
    host: HTMLDivElement
    /** Reference to output in terminal */
    output: HTMLLabelElement;
    /** Reference to input in terminal */
    input: HTMLInputElement;

    constructor(container: HTMLElement) {
        this.termianlHostName = container.id; 
        this.makeTerminal();
        console.log("Creating!")
    }

    makeTerminal(): void {
        this.host = document.createElement("div");
        this.host.id = this.termianlHostName;
        //? is included since tabs still need to get made
        document.getElementById("Terminal")?.replaceWith(this.host);
        //Title
        var title = document.createElement("p");
        title.id = "title";
        title.innerHTML = "Input/Output Terminal";
        this.host.appendChild(title);
        //Output terminal
        var container = document.createElement("div");
        container.id = "container"
        this.host.appendChild(container);
        //Label to display outputs
        this.output = document.createElement("label");
        this.output.id = "output";
        container.appendChild(this.output);
        //Box for input
        var inputContainer = document.createElement("div");
        inputContainer.id = "inputContainer";
        inputContainer.classList.add("subsection");
        this.host.appendChild(inputContainer);
        //Edittext for user's input
        this.input = document.createElement("input");
        this.input.type = "text";
        this.input.placeholder = "";
        inputContainer.appendChild(this.input);
        //Box for buttons
        var buttonContainer = document.createElement("div");
        buttonContainer.id = "buttonContainer";
        buttonContainer.classList.add("subsection");
        this.host.appendChild(buttonContainer);
        //Enter button's on eventListener is set during read
        this.enterBut = document.createElement("button");
        this.enterBut.id = "enter";
        this.enterBut.innerHTML = "Enter";
        buttonContainer.appendChild(this.enterBut);
        //Clear button
        var clearBut = document.createElement("button");
        clearBut.id = "clear";
        clearBut.innerHTML = "Clear";
        clearBut.addEventListener("click", () => this.output.innerHTML = "");
        buttonContainer.appendChild(clearBut);
    }

    print(input:any): void {
        this.output.innerText += ">" + input;
        this.output.innerHTML += "<br/>";
        this.updateContainer();
    }
    
    async read(): Promise<string> {
        this.output.innerText += ">";
        var promise = await new Promise((resolve) => this.enterBut.addEventListener("click", resolve));
        var userInput = this.input.value;
        this.input.placeholder = "";
        this.output.innerText += userInput + "\n"
        this.updateContainer();
        return new Promise((resolve) => resolve(userInput));
    }

    private updateContainer(): void {
        var contain = document.getElementById("container");
        if(contain != null) contain.scrollTop = contain.scrollHeight;
    }


}

export const MainTerminal = new Terminal(document.getElementById("Terminal"));
